(function () {
  if (window.__bookingModalReady) return;
  window.__bookingModalReady = true;

  /*
    iOS Safari does NOT honour overflow:hidden on body.
    Fix: block touchmove on the document when the modal is open,
    but allow it inside the modal container so the iframe can scroll freely.
    (Touch events fired inside a cross-origin iframe never reach the parent
    document anyway, so iframe scrolling is never affected.)
  */
  function preventPageScroll(e) {
    if (e.target.closest && e.target.closest('.booking-modal__container')) return;
    e.preventDefault();
  }

  function lockBodyScroll() {
    document.body.classList.add('booking-modal-open');          // overflow:hidden for desktop
    document.addEventListener('touchmove', preventPageScroll, { passive: false });
  }

  function unlockBodyScroll() {
    document.body.classList.remove('booking-modal-open');
    document.removeEventListener('touchmove', preventPageScroll, { passive: false });
  }

  /* ── Modal open / close ── */
  function openBookingModal(modal, url) {
    /*
      Teleport the modal to <body> before showing it.
      If the modal stays nested inside a Shopify section, any ancestor with
      a CSS transform or will-change creates a new containing block and
      breaks position:fixed on iOS — the modal appears at the document
      position rather than the current viewport position.
      Moving it to <body> removes all ancestor interference.
    */
    if (modal.parentNode !== document.body) {
      modal._prevParent  = modal.parentNode;
      modal._prevSibling = modal.nextSibling;
      document.body.appendChild(modal);
    }

    var iframe = modal.querySelector('.booking-modal__iframe');
    if (iframe) iframe.src = url;
    modal.removeAttribute('aria-hidden');
    modal.classList.add('is-open');
    lockBodyScroll();
  }

  function closeBookingModal(modal) {
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');
    unlockBodyScroll();

    /* Restore the modal to its original place in the DOM */
    if (modal._prevParent) {
      if (modal._prevSibling) {
        modal._prevParent.insertBefore(modal, modal._prevSibling);
      } else {
        modal._prevParent.appendChild(modal);
      }
    }

    var iframe = modal.querySelector('.booking-modal__iframe');
    if (iframe) iframe.src = 'about:blank';
  }

  /*
    Global registry { variantId: { url, sectionId } }
    Built from every [data-booking-variants] on the page.
    Covers main form, sticky bar, quick view — any add-to-cart form.
  */
  var registry = {};

  function buildRegistry() {
    registry = {};
    var wraps = document.querySelectorAll('[data-booking-variants]');
    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];
      var variants;
      try { variants = JSON.parse(wrap.getAttribute('data-booking-variants') || '[]'); }
      catch (_) { continue; }
      if (!variants.length) continue;

      var url       = wrap.getAttribute('data-booking-url')  || '';
      var sectionId = wrap.getAttribute('data-section-id')   || '';
      if (!url || !sectionId) continue;

      for (var j = 0; j < variants.length; j++) {
        if (!registry[variants[j]]) {
          registry[variants[j]] = { url: url, sectionId: sectionId };
        }
      }
    }
  }

  /* Works for hidden input (main form) and <select> (sticky bar) */
  function getVariantId(form) {
    var el = form.querySelector('[name="id"]');
    return el ? parseInt(el.value, 10) : NaN;
  }

  /* ── Intercept 1: button CLICK (capture) ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.product-form__submit');
    if (!btn) return;

    var form = btn.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;

    var id = getVariantId(form);
    if (isNaN(id)) return;

    var booking = registry[id];
    if (!booking) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var modal = document.getElementById('BookingModal-' + booking.sectionId);
    if (!modal) return;

    openBookingModal(modal, booking.url);
  }, true);

  /* ── Intercept 2: form SUBMIT (capture) — catches requestSubmit() too ── */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;

    var id = getVariantId(form);
    if (isNaN(id)) return;

    var booking = registry[id];
    if (!booking) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var modal = document.getElementById('BookingModal-' + booking.sectionId);
    if (!modal) return;

    openBookingModal(modal, booking.url);
  }, true);

  /* ── Close: X button or dark overlay ── */
  document.addEventListener('click', function (e) {
    var isClose   = !!(e.target.closest && e.target.closest('.booking-modal__close'));
    var isOverlay = e.target.classList && e.target.classList.contains('booking-modal__overlay');
    if (!isClose && !isOverlay) return;
    var modal = e.target.closest && e.target.closest('.booking-modal');
    if (modal) closeBookingModal(modal);
  });

  /* ── Close: Escape key ── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.booking-modal.is-open');
      if (open) closeBookingModal(open);
    }
  });

  /* ── Build registry once DOM is ready ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildRegistry);
  } else {
    buildRegistry();
  }

}());
